<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea"></div>
      <div class="scrollY">
        <div class="icon fail"></div>
        <h5>{{ t('skillCertify-caution') }}</h5>
        <p v-html="convertToNextLine(t('skillCertify-caution-multiple-monitor'))" />
        <div v-if="!isMultiMonitor" class="boxArea">
          <span class="ic"></span>{{ t('skillCertify-caution-multiple-monitor-enable') }}
        </div>
        <div v-if="isMultiMonitor" class="boxArea">
          <span class="ic none"></span>{{ t('skillCertify-caution-multiple-monitor-disable-1') }}<br>{{ t('skillCertify-caution-multiple-monitor-disable-2') }}
        </div>
        <div class="btnArea">
          <button :class="{disabled: isMultiMonitor}" :disabled="isMultiMonitor" @click.stop="onClickClose">{{ t('common-continue') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "#imports";
import { useDialogStore } from "~/store/dialog/dialogStore";
import { useI18n } from "vue-i18n";
import { useLearningAssessmentStore } from "~~/application/store/learning/assessment/learningAssessmentStore";
import {
  useLearningScreenRecordingService
} from "~~/application/composables/service/useLearningScreenRecordingService";
import { useFullscreenService } from "~~/application/composables/service/useFullscreenService";
import DialogType from "~~/application/components/Common/Dialog/model/DialogType";
import { RecorderDomainType } from "~~/package/mapper/recorder/model/RecorderDomainType";
import { convertToNextLine } from "~~/application/utils/StringUtil";

const { t } = useI18n();
const dialogStore = useDialogStore();
const assessmentStore = useLearningAssessmentStore();
const learningScreenRecordingService = useLearningScreenRecordingService();
const fullscreenService = useFullscreenService();
const domainType = ref<RecorderDomainType>(RecorderDomainType.NONE);

const isMultiMonitor = ref(false);
const multiMonitorIntervalId = ref(0)

onMounted(() => {
  isMultiMonitor.value = window.screen.isExtended as boolean
  domainType.value = dialogStore.multiOption.find(option => option.type === DialogType.CautionMultiMonitorPopup)?.props.domainType

  multiMonitorIntervalId.value = setInterval(() => {
    isMultiMonitor.value = window.screen.isExtended as boolean
  }, 1000)
})

const onClickClose = async () => {
  dialogStore.deleteMultiOption({
    type: DialogType.CautionMultiMonitorPopup
  })
  await learningScreenRecordingService.startRecording(domainType.value);
  await fullscreenService.ensureFullscreen();
  assessmentStore.cautionFlag.multiMonitor = true;
  clearInterval(multiMonitorIntervalId.value)
};

</script>

